<template>
  <transition name="fade">
    <div v-show="visible" :class="{active: visible}" class="lightbox-wrapper">
      <div class="lightbox-content">
        <section class="info_btn" @click="handleClose()">
          <div>
            <p>
              <span>
                <svg class="icon-info_large">
                  <use xlink:href="#icon-Info_large"></use>
                </svg>
              </span>
              {{txt.common.more_information}}
            </p>
          </div>
          <div>
            <ul>
              <li>
                <h2></h2>
                <p></p>
              </li>
              <li></li>
            </ul>
          </div>
        </section>
        <section class="info_toggle">
          <slot></slot>
        </section>
      </div>
    </div>
  </transition>
</template>

<script>
import { mapState } from "vuex";
export default {
  props: {
    visible: {
      type: Boolean,
      required: true,
      default: false
    }
  },
  computed: {
    ...mapState({
      txt: state => state.txt
    })
  },
  methods: {
    handleClose() {
      this.$emit("close");
    }
  }
};
</script>
